export default __webpack_public_path__ + "static/media/Skye_artwork.b85da563.png";